<div style="height: 65px;">
    <app-navbar #navbarlayout></app-navbar>
</div>
<app-side-menu></app-side-menu>
<div #layoutWrapper [style.height]="'calc(100vh - ' + 65 + 'px)'" style="overflow-y: scroll;">
    
    <div *ngIf="subscriptionBanners?.length" class="d-flex flex-column align-items-center justify-content-center w-100" (click)="gotoSubscriptionDetails()">
        <ng-container *ngFor="let banner of subscriptionBanners">
            <div *ngIf="!banner?.hide" class="w-100 px-1">
                <div class="alert d-flex align-items-center justify-content-between w-100 my-1 mb-0 py-2"
                    [ngClass]="'alert-' + SubscriptionBannerService.getSeverity(banner.Severity)" role="alert" style="position: relative;">

                    <div class="d-flex align-items-center ">
                        <i class="bi mr-3" [ngClass]="SubscriptionBannerService.getSeverityIcon(banner.Severity)" [ngStyle]="{'color': SubscriptionBannerService.getBannerColor(banner.Severity)}" style="font-size: 22px;"></i>
                        <div class="d-flex flex-column align-items-start w-100">
                            <span class="font-weight-bold " [ngStyle]="{'color': SubscriptionBannerService.getBannerColor(banner.Severity)}">
                                {{ banner.Title | uppercase }}
                            </span>
                            <span class="small flex-grow-1">
                                {{ banner.Message }}
                            </span>
                        </div>
                    </div>
                    
                    <button *ngIf="banner.Closable" type="button" class="close ml-2" aria-label="Close"
                        (click)="closeBanner(banner)" style="position: absolute; top: 4px; right: 4px;" >
                        <span aria-hidden="true">&times;</span>
                    </button>
                </div>
            </div>
        </ng-container>
    </div>

    <router-outlet></router-outlet>
</div>